import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareRoadmapRoute: InvariantJiraRoute = {
	name: 'software-roadmap',
	path: '/jira/software/projects/:projectKey/boards/:boardId/roadmap',
};
